import { createAction } from 'redux-actions';

export const clearReservationPending = createAction(
  'CLEAR_RESERVATION_PENDING'
);

export const reservationPendingOnChangePage = createAction(
  'RESERVATION_PENDING_ON_CHANGE_PAGE'
);

export const reservationPendingOnChangeOrder = createAction(
  'RESERVATION_PENDING_ON_CHANGE_ORDER'
);

export const reservationPendingRemoveItem = createAction(
  'RESERVATION_PEDING_REMOVE_ITEM'
);
